angular.module('smartorg.r6.navs.navbar').directive("rangalNav", ['$timeout', 'terminologyService', function ($timeout, terminologyService) {
        return {
            restrict: 'E',
            template: require('../../template/navbar.html'),
            transclude: true,
            scope: {
                portfolioData: "=",
                userName: "=",
                userEmail: "@",
                isAdmin: "@",
                versionLog: "=",
                versionModalTitle: "=",
                terminology: "=",
                onZendeskRedirect: "&",
                onSelectPortfolio: "&",
                calcEngineState: '=?',
                showLogout: '<?',
                zendeskToggle: '=',
                showTutorial: '<',
                calcEngineAccess: '<?',
                userPortfolioAccess: '<?'
            },
            link: function (scope) {
                console.log('🔍 DEBUG: navbar-directive.ts - Link function called');
                scope.showCalcEngineStateBox = false;
                // Initialize terminology with defaults if not provided by parent
                if (!scope.terminology) {
                    scope.terminology = {
                        Portfolio: 'Portfolio',
                        portfolio: 'portfolio',
                        aPortfolio: 'a portfolio',
                        portfolios: 'portfolios',
                        Portfolios: 'Portfolios',
                        loaded: false // Not loaded from server config
                    };
                }
                console.log('🔍 DEBUG: navbar-directive.ts - Terminology state:', scope.terminology);
                /**
                 * Highlight selected portfolio.
                 */
                scope.$on('manage:SelectedPortfolio', function (event, args) {
                    scope.selectTreeName = args.selectedPortfolio;
                });
                /**
                 * When select a portfolio.
                 *
                 * @param portfolio {{text: string}} Text is also the unique
                 *     key of portfolio. Also same as tree root id display.
                 */
                scope.portfolioClicked = function (portfolio) {
                    scope.selectTreeName = portfolio.text;
                    scope.onSelectPortfolio({ treeID: portfolio.text });
                };
                scope.isSOrgAdminUser = function () {
                    return scope.isAdmin == 'true' && scope.userEmail && scope.userEmail.endsWith('@smartorg.com');
                };
                scope.isAdminUser = function () {
                    return scope.isAdmin == 'true';
                };
                /**
                 * For administrative menu items.
                 *
                 * @param command {string}
                 */
                scope.triggerEmit = function (command) {
                    scope.$emit('workbench:emit', {
                        command: command
                    });
                };
                scope.logout = function () {
                    scope.$emit('workbench:logout');
                };
                $timeout(function () {
                    $('[data-toggle="popover"]').popover();
                });
                // scope.closeTreeContextMenu = function () {
                //     document.getElementById("contextMenu").style.display = 'none';
                // };
            }
        };
    }]);
//# sourceMappingURL=navbar-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/navbar/app/js/plumbing/navbar-directive.js